import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';

const LoadingPage = (props) => {
    useEffect(() => {
        props.toggleSpinner(true);
    }, []);

    return <CommonPage />;
};

export default connect(null, { toggleSpinner })(LoadingPage);
